import { Alert, Box, Button, CircularProgress, Modal, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { COLOR_PRIMARY_1, COLOR_SUCCESS_1 } from 'src/colors';
import { callApi } from 'src/core/callApi';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const ApiCallsTracker = () => {
  const [showAuthTokenModal, setShowAuthTokenModal] = useState<boolean>(false);
  const [dailyCallsRawData, setDailyCallsRawData] = useState<any>();
  const [formattedData, setFormattedData] = useState<any>([]);
  const [userName, setUserName] = useState<string>('');
  const [startingDate, setStartingDate] = useState<string>('')
  const authToken = localStorage.getItem('B2BAuthTokenForApiCallLogs') || null;

  useEffect(() => {
    if (!authToken) {
      setShowAuthTokenModal(true);
    } else {
      fetchDailyUsageApiData(authToken);
    }
  }, []);

  useEffect(() => {
    if (dailyCallsRawData && startingDate) {
      let formatedData: any[] = [];
      for (let date in dailyCallsRawData) {
        if(new Date(startingDate) <= new Date(date)){
          formatedData.push({
            date: date,
            calls: dailyCallsRawData[date],
          });
        }
      }
      setFormattedData(formatedData);
    }
  }, [dailyCallsRawData, startingDate]);

  const AuthTokenModal = () => {
    const [authToken, setauthToken] = useState<string>('');
    const [showEnterAuthTokenAlert, setShowEnterAuthTokenAlert] = useState<boolean>(false)

    const handleSaveAuthToken = authToken => {
      if(authToken) {
        setShowAuthTokenModal(false);
        localStorage.setItem('B2BAuthTokenForApiCallLogs', authToken);
        fetchDailyUsageApiData(authToken);
      }else{
        setShowEnterAuthTokenAlert(true)
      }
    };
    return (
      <Modal
        open={showAuthTokenModal}
        // onClose={() => {
        //   setShowAuthTokenModal(!showAuthTokenModal);
        // }}
      >
        <Box
          sx={{
            width: '50vw',
            height: showEnterAuthTokenAlert ? '140px' : '120px',
            background: '#fff',
            position: 'absolute',
            top: '40%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '30px',
            borderRadius: 4,
            outline: 'none',
          }}
        >
          <Typography variant="h5">Enter the client's authorization token:</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            <TextField
              id="outlined-basic"
              variant="outlined"
              label="Auth Token"
              value={authToken}
              onChange={e => {
                setauthToken(e.target.value);
              }}
              sx={{ width: '100%' }}
            />
            <Button
              sx={{
                backgroundColor: COLOR_SUCCESS_1,
                color: 'white',
                ':hover': { backgroundColor: COLOR_SUCCESS_1 },
              }}
              onClick={() => {
                handleSaveAuthToken(authToken);
              }}
            >
              Save
            </Button>
          </Box>
          {showEnterAuthTokenAlert && <Alert severity="warning" sx={{marginTop:'10px'}}>Enter Auth token.</Alert>}
        </Box>
      </Modal>
    );
  };

  const fetchDailyUsageApiData = async token => {
    setFormattedData([]);
    let URL =
      'https://niwh4e2hbc.execute-api.us-east-2.amazonaws.com/default/getB2BApiDailyLevelRecords';
    const config = { token: token };
    const res = await callApi(URL, { queryParams: config }, false);
    // console.log('Response: ', res);
    setDailyCallsRawData(res['daily_level_api_calls']);
    setUserName(res['name']);
    setStartingDate(res['starting_date']);
  };

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
      }}
    >
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <AuthTokenModal />
        <Button
          variant="contained"
          sx={{ padding: '10px', margin: '15px 15px 0px 0px' }}
          onClick={() => {
            setShowAuthTokenModal(true);
          }}
        >
          <Typography variant="body1">Reset Token</Typography>
        </Button>
      </Box>
      {formattedData.length > 0 && (
        <Box
          sx={{
            height: '80%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography>
            API calls usage for : <span style={{ fontWeight: 500 }}>{userName}</span>
          </Typography>
          <Box sx={{ height: '50%', width: '70%' }}>
            <ResponsiveContainer height={400} width="100%">
              <BarChart
                width="100%"
                height="100%"
                data={formattedData}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend iconType="circle" iconSize={10} wrapperStyle={{ color: 'black' }} />
                <Bar dataKey="calls" stackId="a" fill={COLOR_PRIMARY_1} />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        </Box>
      )}
      {formattedData.length == 0 && (
        <Box
          sx={{
            height: '80%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default ApiCallsTracker;
